import api from "./api";

/**
 * api.baseURL = https://api.idlogichain.com/api
 * so here we use paths WITHOUT /api
 */
const BASE = "/address";

/* =========================
   GET ALL ADDRESSES
   GET /api/address
   ========================= */
export const getAddresses = async () => {
    const res = await api.get(BASE);
    return res.data;
};

/* =========================
   GET ADDRESS BY ID
   GET /api/address/{id}
   ========================= */
export const getAddressById = async (id) => {
    const res = await api.get(`${BASE}/${id}`);
    return res.data;
};

/* =========================
   GET BY POSTAL CODE
   GET /api/address/postalcode/{id}
   ========================= */
export const getAddressByPostalCode = async (postalCodeId) => {
    const res = await api.get(`${BASE}/postalcode/${postalCodeId}`);
    return res.data;
};

/* =========================
   GET BY CITY
   GET /api/address/city/{id}
   ========================= */
export const getAddressByCity = async (cityId) => {
    const res = await api.get(`${BASE}/city/${cityId}`);
    return res.data;
};

/* =========================
   GET BY COUNTRY
   GET /api/address/country/{id}
   ========================= */
export const getAddressByCountry = async (countryId) => {
    const res = await api.get(`${BASE}/country/${countryId}`);
    return res.data;
};

/* =========================
   CREATE ADDRESS
   POST /api/address
   ========================= */
export const createAddress = async (data) => {
    const res = await api.post(BASE, data);
    return res.data;
};

/* =========================
   UPDATE ADDRESS
   PUT /api/address/{id}
   ========================= */
export const updateAddress = async (id, data) => {
    const res = await api.put(`${BASE}/${id}`, data);
    return res.data;
};

/* =========================
   DELETE ADDRESS
   DELETE /api/address/{id}
   ========================= */
export const deleteAddress = async (id) => {
    const res = await api.delete(`${BASE}/${id}`);
    return res.data;
};

export default {
    getAddresses,
    getAddressById,
    getAddressByPostalCode,
    getAddressByCity,
    getAddressByCountry,
    createAddress,
    updateAddress,
    deleteAddress,
};